module.exports = __webpack_public_path__ + "static/media/mainSlider.309c8ce2.jpg";